module.exports = __webpack_public_path__ + "static/media/planning-for-success@3x.a64ee08c.png";